
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1095_194)"}},[_c('path',{attrs:{"d":"M22.669 14.964c.047-.37.082-.744.082-1.125 0-.38-.035-.755-.082-1.124l2.468-1.91a.57.57 0 00.14-.737L22.942 6.07c-.146-.248-.449-.352-.712-.248l-2.905 1.159a8.876 8.876 0 00-1.971-1.136l-.438-3.057a.598.598 0 00-.583-.484h-4.667a.587.587 0 00-.577.484l-.438 3.057a8.658 8.658 0 00-1.971 1.136l-2.905-1.16a.587.587 0 00-.712.249l-2.333 3.997a.573.573 0 00.14.738l2.461 1.909c-.046.369-.081.744-.081 1.124 0 .381.035.756.081 1.125l-2.461 1.909a.57.57 0 00-.14.738l2.333 3.997c.146.248.45.352.712.248l2.905-1.16c.6.456 1.26.843 1.971 1.137l.438 3.057a.587.587 0 00.577.484h4.667c.292 0 .53-.213.578-.484l.437-3.057a8.656 8.656 0 001.972-1.136l2.905 1.159c.262.098.566 0 .711-.248l2.334-3.997a.573.573 0 00-.14-.738l-2.462-1.909zm-8.668 2.912c-2.258 0-4.084-1.805-4.084-4.037s1.826-4.037 4.084-4.037c2.257 0 4.083 1.805 4.083 4.037s-1.826 4.037-4.083 4.037z","fill":"#007185"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1095_194"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v27.683H0z"}})])])])
          )
        }
      }
    